import { hover } from 'javascripts/utils/hide-show';
import NavigationOverlay from './navigation.overlay';

// Event registry
let eventRegistry = [];

document.querySelectorAll('.navigation').forEach(($navigation) => {
  const navigationOverlay = new NavigationOverlay($navigation);
  // Init media query
  const mql = window.matchMedia('(min-width: 1280px)');

  // Listener
  const onMediaQueryChange = (mq) => {
    const isDesktop = mq.matches;

    if (isDesktop) {
      navigationOverlay.deinit();

      document.querySelectorAll('.navigation__item-link--main[aria-haspopup="true"]').forEach(($link) => {
        $link.addEventListener('mousedown', e => e.preventDefault());
        eventRegistry.push(hover($link, 200));
      });
    } else {
      // Kill all event handlers on switch
      eventRegistry.forEach(e => e());
      eventRegistry = [];

      navigationOverlay.init();
    }
  };

  // Listen on media query changes
  mql.addListener(onMediaQueryChange);

  // First run
  onMediaQueryChange(mql);
});
